import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { RadioOption } from '../../../_models/RadioOption';
import { MatRadioChange } from '@angular/material/radio';


@Component({
  selector: 'app-fare-table-sale-type-filter',
  templateUrl: './fare-table-sale-type-filter.component.html',
  styleUrls: ['./fare-table-sale-type-filter.component.scss']
})
export class FareTableSaleTypeFilterComponent implements OnInit {
  @Output() isOnSaleTypeChange = new EventEmitter();

  public checked;

  public filterOpts: RadioOption[];
  public selectedFilterOpt: string;

  constructor() { }

  ngOnInit() {
    this.filterOpts = [
      { value: 'happy_hour', label: 'Happy Hour'},
      { value: 'advance_purchase', label: 'Advance Purchase'},
      { value: 'tier_1', label: 'Tier 1'},
      { value: 'tier_2', label: 'Tier 2'}
    ];
  }
  onFilterSelect(event: MatRadioChange) {
    this.selectedFilterOpt = event.value;
    this.isOnSaleTypeChange.emit(event.value);
  }

  onResetFilter() {
    this.ngOnInit();
    this.selectedFilterOpt = '';
    this.isOnSaleTypeChange.emit('');
  }
}
